<template>
    <v-card class="rounded-4"> 
        <v-toolbar flat height="45px">  
            <b>My Teams</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>                      
        </v-toolbar>
        <v-card-text class="pl-30 pr-30">
            <div :class="isMobile?'wp-100 mb-10':'wp-50 mb-10'">
                <v-text-field v-model="search" append-icon="search" label="Search team" single-line hide-details clearable></v-text-field>  
            </div>
            <v-data-table
                :headers="headers"
                :items="my_teams_filtered"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="paginationSync"
            >
                <template v-slot:items="props">
                    <tr @click="selectTeam(props.item)" title="Click to select team" class="clickable">
                        <td>{{ props.item.name }}</td>
                        <td>
                            <div v-if="getSupervisors(props.item).length" >
                                 <v-chip small v-for="(item,index) in getSupervisors(props.item)" :key="index" class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.employee.userId)"></v-img>
                                    </v-avatar>
                                    {{item.employee.firstName}} {{item.employee.lastName}}
                                </v-chip>
                            </div>
                        </td>
                        <td>
                            <div v-if="getManagers(props.item).length" >
                                 <v-chip small v-for="(item,index) in getManagers(props.item)" :key="index" style="margin:-5px 0px 0px -5px;">
                                    <v-avatar>
                                       <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.employee.userId)"></v-img>
                                    </v-avatar>
                                    {{item.employee.firstName}} {{item.employee.lastName}}
                                </v-chip>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>

import { getSort, getSearchKeyword, getRowsPerPage, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    data () {
        const routeName = `${this.$route.name}-ViewAllMyTeamsPopup`
        const savedSort = getSort(routeName)
        
        return {
            awsS3Helper,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: getSearchKeyword(routeName),
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Team', align: 'left', value: 'firstName', width:'50%', sortable:true},
                {text: 'Supervisors', align: 'left', value: 'status', width: '25%', sortable:true},
                {text: 'Managers', align: 'left', value: 'status', width: '25%', sortable:true}
            ],
            my_teams: []
        }   
    },
    methods: {
        getSupervisors(data) {
            return data.members.filter(x => x.role == 'Supervisor')
        },
        getManagers(data) {
            return data.members.filter(x => x.role == 'Manager')
        },
        selectTeam(data) {
            this.$emit('send', data)
            this.closeDialog()
        },
        setData(data) {
            this.my_teams = data
        },
        closeDialog() {
            this.$emit('update:dialogAllMyTeams', false)
        },
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.pageName, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.pageName, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.pageName, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.pageName, newVal)
        }
    },
    computed: {
        my_teams_filtered() {
            var temp = this.my_teams

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.name.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        pageName() {
            return `${this.$route.name}-ViewAllMyTeamsPopup`
        }
    }
}
</script>